import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import qs from 'qs';

// action
import actions from '../../../../actions/search';

// component
import SearchFields from './parts/SearchFields';

class SearchForm extends Component {
  constructor(props, { initialRender, customStore }) {
    super();
    const { fetchSearchResults, location } = props;
    this.buildSearchQuery = this.buildSearchQuery.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.resetSearch = this.resetSearch.bind(this);
    this.updateActiveType = this.updateActiveType.bind(this);
    this.updateFormValues = this.updateFormValues.bind(this);
    this.updateSelectArtist = this.updateSelectArtist.bind(this);

    let activeType = 'all';
    const queryArgs = ['?page=1'];
    if (location && location.search !== '') {
      const parsedQueryString = qs.parse(props.location.search.slice(1));

      if (parsedQueryString.filterCategory && parsedQueryString.filterCategory !== '') {
        activeType = parsedQueryString.filterCategory || 'all';
        queryArgs.push(`post_type=${parsedQueryString.filterCategory}`);
      }

      if (parsedQueryString.schoolLevel && parsedQueryString.schoolLevel !== '') {
        queryArgs.push(`school-level-category=${parsedQueryString.schoolLevel}`);
      }

      if (parsedQueryString.keywords && parsedQueryString.keywords !== '') {
        queryArgs.push(`keywords=${parsedQueryString.keywords}`);
      }
    }
    const searchQuery = queryArgs.join('&');
    this.state = {
      activeType,
      selectArtist: [],
    };
    if (initialRender) {
      fetchSearchResults(encodeURI(searchQuery), customStore);
    }
  }

  componentDidMount() {
    const { fetchSearchResults, location } = this.props;
    const parsedQueryString = qs.parse(location.search.slice(1));
    const searchQuery = this.buildSearchQuery(parsedQueryString);
    if (parsedQueryString && parsedQueryString.filterCategory) {
      this.updateActiveType(parsedQueryString.filterCategory);
    }
    fetchSearchResults(encodeURI(searchQuery ? `${searchQuery}&page=1` : '?page=1'));
  }

  buildSearchQuery(values) {
    const { setQuery, artistsSlugs } = this.props;
    const { selectArtist } = this.state;
    const selectArtistsSlugs = selectArtist
      .map(artist => Object.keys(artistsSlugs).find(key => artistsSlugs[key] === artist));
    const queryValues = Object.keys(values).reduce((obj, key) => {
      if (key === 'filterCategory') {
        obj.post_type = values[key];
      } else if (key === 'schoolLevel' && values[key] !== 'all') {
        obj['school-level-category'] = values[key];
      } else if (typeof values[key] === 'boolean' && values[key] === true) {
        const filterKey = key.substr(0, key.indexOf('__'));
        const fieldValue = key.substr(key.indexOf('__') + 2);
        if (obj[filterKey]) {
          obj[filterKey] = `${obj[filterKey]},${fieldValue}`;
        } else {
          obj[filterKey] = fieldValue;
        }
      } else {
        obj[key] = values[key];
      }
      return obj;
    }, {});
    if (selectArtist) {
      queryValues['artist-term'] = selectArtistsSlugs.toString();
    }
    const searchQuery = Object.keys(queryValues).reduce((query, key) => {
      if (query === '') {
        query = `?${key}=${queryValues[key]}`;
      } else {
        query = `${query}&${key}=${queryValues[key]}`;
      }
      return query;
    }, '');

    setQuery(searchQuery);
    return searchQuery;
  }

  handleFormSubmit(values) {
    const { fetchSearchResults, history } = this.props;
    if (values.filterCategory && values.filterCategory !== 'all') {
      history.push({ search: `?filterCategory=${values.filterCategory}` });
    } else {
      history.push({ search: '' });
    }
    const searchQuery = this.buildSearchQuery(values);
    if (window) {
      window.scrollTo(0, 0);
    }
    fetchSearchResults(encodeURI(`${searchQuery}&page=1`));
  }

  updateFormValues(value) {
    const { changeFieldsValues, formValues } = this.props;
    if (typeof formValues[value] === 'boolean') {
      changeFieldsValues(value, false);
    } else {
      changeFieldsValues(value, '');
    }
  }

  updateActiveType(value) {
    this.setState({ activeType: value, selectArtist: [] });
  }

  updateSelectArtist(value) {
    this.setState({
      selectArtist: value,
    });
  }

  resetSearch() {
    const { fetchSearchResults, history, reset, change } = this.props;
    reset();
    change('filterCategory', 'all');
    history.push({ search: '' });
    if (window) {
      window.scrollTo(0, 0);
    }
    fetchSearchResults(encodeURI('?page=1'));
  }

  render() {
    const {
      filters,
      formValues,
      handleSubmit,
      submitting,
      isLoading,
      isLoadingFilters,
      reset,
    } = this.props;
    const { selectArtist } = this.state;
    const { activeType } = this.state;
    const submitForm = handleSubmit(this.handleFormSubmit);

    return (
      <form onSubmit={submitForm} className="search__filters">
        <SearchFields
          filters={filters}
          isLoading={isLoading}
          isLoadingFilters={isLoadingFilters}
          submitting={submitting}
          activeType={activeType}
          updateActiveType={this.updateActiveType}
          reset={reset}
          resetSearch={this.resetSearch}
          formValues={formValues}
          selectArtist={selectArtist}
          updateFormValues={this.updateFormValues}
          updateSelectArtist={this.updateSelectArtist}
        />
      </form>
    );
  }
}

SearchForm.propTypes = {
  change: PropTypes.func.isRequired,
  artistsSlugs: PropTypes.object.isRequired,
  changeFieldsValues: PropTypes.func.isRequired,
  fetchSearchResults: PropTypes.func.isRequired,
  filters: PropTypes.array.isRequired,
  formValues: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isLoadingFilters: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
  reset: PropTypes.func.isRequired,
  setQuery: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
};

function mapStateToProps(state, ownProps) {
  let filterCategory = 'all';
  let keywords = '';
  let schoolLevel = '';
  if (ownProps.location && ownProps.location.search) {
    const parsedQueryString = qs.parse(ownProps.location.search.slice(1));
    filterCategory = parsedQueryString.filterCategory || 'all';
    keywords = parsedQueryString.keywords || '';
    schoolLevel = parsedQueryString.schoolLevel || '';
  }

  const initialValues = {
    filterCategory,
    keywords,
  };

  if (schoolLevel && schoolLevel !== 'all') {
    initialValues[`school-level-category__${schoolLevel}`] = true;
  }
  return {
    artistsSlugs: state.search.artistsSlugs,
    formValues: state.form.search ? state.form.search.values : {},
    initialValues,
  };
}

export default withRouter(connect(mapStateToProps, actions)(reduxForm({
  form: 'search',
  enableReinitialize: false,
})(SearchForm)));



// WEBPACK FOOTER //
// ./src/app/components/pages/search/form/SearchForm.js